import {RESOLVE_THEME_FROM_URL} from '.';
import 'url-search-params-polyfill';
import defaultTheme from '../constants/DefaultTheme';
import {createMuiTheme} from "@material-ui/core";
import toHex from 'colornames';

const resolveThemeFromUrl = ({dispatch}) => {
  let queryParams = new URLSearchParams(document.location.search.substring(1));
  let primaryColor = queryParams.get("primaryColor");
  let accentColor = queryParams.get("accentColor");

  let theme = {};
  Object.assign(theme, defaultTheme);

  if (primaryColor) {
    if(!primaryColor.startsWith("#")) {
      primaryColor = toHex(primaryColor);
    }
    theme.palette.primary.light = primaryColor;
    theme.palette.primary.main  = primaryColor;
    theme.palette.primary.dark  = primaryColor;
  }

  if (accentColor) {
    if(!accentColor.startsWith("#")) {
      accentColor = toHex(accentColor);
    }
    theme.palette.secondary.light = accentColor;
    theme.palette.secondary.main = accentColor;
    theme.palette.secondary.dark = accentColor;
  }

  dispatch({
    type: RESOLVE_THEME_FROM_URL,
    theme: createMuiTheme(theme)
  });
};

export default resolveThemeFromUrl;
